import isEmpty from "lodash-es/isEmpty"

import { ECoachRatingType, type ICoachRatingDto, type ICoachRatingModel, type ICoachRatingTypeDto } from "@/3514/types"

function _getRatingEnumFromType(type: ICoachRatingTypeDto): ECoachRatingType {
    switch (type) {
        case "post-module":
            return ECoachRatingType.PostModule
        case "offboarding":
            return ECoachRatingType.Offboarding
        default:
            return null
    }
}

function coachRatingAdapter(dto: ICoachRatingDto): ICoachRatingModel {
    return isEmpty(dto)
        ? null
        : {
              id: dto.id,
              questionKey: _getRatingEnumFromType(dto.question_key),
              questions: isEmpty(dto.questions_data)
                  ? null
                  : {
                        mainQuestion: dto.questions_data.main_question,
                        oneStarQuestion: dto.questions_data.one_star_question,
                        twoStarQuestion: dto.questions_data.two_star_question,
                        threeStarQuestion: dto.questions_data.three_star_question,
                        fourStarQuestion: dto.questions_data.four_star_question,
                        fiveStarQuestion: dto.questions_data.five_star_question
                    },
              isRequired: dto.required,
              productTypeId: dto.product_type,
              freeResponsePrompt: dto.free_response_promt
          }
}

export { coachRatingAdapter }
